import * as ReactService from "@intech/react-service";
import { ProcessoBeneficioEntidade } from "../entidades/ProcessoBeneficioEntidade";

class ProcessoBeneficio extends ReactService.BaseService {
  constructor() {
    super("ProcessoBeneficio");
  }

  BuscarPorPlano = (cdplano: string) =>
    this.CreateRequest<ProcessoBeneficioEntidade[]>(ReactService.RequestType.GET, `BuscarPorPlano/${cdplano}`);

  BuscarExtratoAssistidoPorPlanoEspecieNumeroProcessoAnoProcesso = (cdPlano: string, especie: string, numero: number, ano: string) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `BuscarExtratoAssistidoPorPlanoEspecieNumeroProcessoAnoProcesso/${cdPlano}/${especie}/${numero}/${ano}`);

  GerarRelatorioExtratoCD = (cdPlano: string, especie: string, numero: number, ano: string, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GerarRelatorioExtratoCD/${cdPlano}/${especie}/${numero}/${ano}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

}

export const ProcessoBeneficioService = new ProcessoBeneficio();
